import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/dojome',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://twitter.com/chief_victoru',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'mailto:chief.victoru@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
